<template>
  <footer class="footer" id="footer">
    <div class="fl about">
      <div class="left">
        <img :src="logo" alt="logo" width="100">
        <p class="about-us text">
          We are an Affiliate Network with over 1000 direct offers in major verticals across all over the world.
          With our 24 hours support system, Monthly payment toefine Performance marketing and take it over by storm.
          Work with us today and you will be ever happy you did.
        </p>
      </div>
    </div>
    <div class="fl about">
      <div class="center">
        <h4>Quick Links</h4>
        <ul>
          <li class="text"
            v-for="(menu, i) of menus" :key="i">
            <router-link  v-if="menu.url"
              :to="menu.url">
              {{menu.text}}
            </router-link>
            <a v-else :href="menu.http">{{menu.text}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="fl about">
      <div class="right">
        <h4 style="margin-bottom: 0.3125rem;">Keep in Touch</h4>
        <div class="text" v-for="(connectWay,i) of connectUs" :key="i">
          <i :class="['iconfont', connectWay.icon]"></i>
          <span>{{connectWay.content}}</span>
        </div>
        <div style="margin-top: 1.875rem;">
        	<span style="font-size: 1.625rem;" class="iconfont icon-facebook"></span>
        	<span style="font-size: 1.625rem;margin-left: 1.25rem;" class="iconfont icon-in2-copy"></span>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data () {
    return {
      menus: [
        {
          text: 'Home',
          url: '/'
        },
        {
          text: 'Advertiser',
          url: '/advertiser'
        },
        {
          text: 'Affiliate',
          url: '/affiliate'
        },
        {
          text: 'Company',
          url: '/company'
        },
        {
          text: 'Categories',
          url: '/campaign'
        },
        {
          text: 'Blog',
          url: ''
        },
        {
          text: 'Login',
          http: 'http://taptap.offerslook.com'
        }
      ],
      connectUs: [
        {
          icon: 'icon-skype',
          content: 'Vicky（live: .cid.a470b9e526bccf4d）/ Lizel（live: 15316004）'
        },
        {
          icon: 'icon-youjian',
          content: 'vicky@soygame.cn / lizel@soygame.cn'
        },
        {
          icon: 'icon-fangzihouse128',
          content: 'FLAT B5, 1/F MANNING IND. BUILDING, 116-118 HOW MING STREET, KWUN TONG, KOWLOON, HONG KONG'
        }
      ],
      logo: require('@/assets/images/logo1.png'),
      activeI: 0
    }
  }
}
</script>
<style lang="scss">
.footer {
	// position: absolute;
	// bottom: 0;
  overflow: hidden;
  padding: 3.125rem 8rem 2.75rem 7.375rem;
  background-color: #121212;
  color: #fff;
  // img {
  //   // /*width: 108px*/
  // }
  .about {
    width: 33%;
  }
  p {
    // font-size: 14px;
    // font-weight: 500;
    // line-height: 27px;
    text-align: justify;
  }
  .left {
    text-align: left;
    padding-right: 0.9375rem;
  }
  .center {
    padding: 0 0.9375rem 0 2.8125rem;
    text-align: left;
  }
  .right {
    padding-left: 0.9375rem;
    text-align: right;
    div {
    	margin-bottom: 0.625rem;
    }
  }
  .text {
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.6875rem;
  }
  h4 {
    font-size: 1.4375rem;
    font-weight: 800;
    line-height: 1.875rem;
  }

  ul {
    list-style: none;
    padding: 0;
    li {
      /*padding-bottom: 14px;*/
      a {
        text-decoration: none;
        color: #818181;
        &:hover {
          color: #fff;
        }
      }
    }
  }
}
@media screen and (max-width: 760px) {
  #footer {
    padding: 0 2rem;
    .about {
      width: 100%;
      .center, .right {
        text-align: left;
        padding: 0;
      }
      .left p {
        text-align: left;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue